import axios from "axios";
import Vue from "vue";
import store from "../store/store";
import { Toast } from "vant";
import myJsTools from "@/utils/myJsTools";
// 这个是主要是腾讯SDK去使用，UI是全屏蒙版
import { stopLoading, checkAppointDataChange, checkNotReceiveDataChange } from '@/utils/public';
// 这个主要是接口使用，UI是vant2的加载中弹窗
import loadingManager from "@/utils/loadingManager";
import reSetData from "./base";

Vue.use(Toast);
import router from "../router";

let baseURL = process.env.VUE_APP_API_URL;
// let baseURL = 'https://gw-prod.ailianjk.com/hospital/'
let firmId = process.env.firmId;
let appV;
if (process.env.NODE_ENV == "development") {
  firmId = "dev";
}

// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  timeout: 50000 // 请求超时时间
});

let curConfig;
// request拦截器
service.interceptors.request.use(
  config => {
    curConfig = config
    // store.commit("setShowLoading", true);
    if (config.loading) {
      loadingManager.show();
    }
    let token_info = myJsTools.getItem("token_info");
    var token = "";
    if (token_info) {
      token = token_info.token || "";
      let hosId = token_info.hosId || "";
      config.headers.Authorization = `${token}`;
      if (token_info.hosId) {
        config.headers.hosId = `${hosId}`;
      }
    }
    if (!config.headers.hosId) {
      config.headers.hosId = "";
    }
    // 版本号修改
    // 移动端1.2.3 和本地1.3.5
    config.headers.version = "1.3.7";
    config.headers.firmId = 'siv6k7x1';
    config.headers.clientType = "A";
    config.headers.userRole = "doctor";
    // if (process.env.NODE_ENV != "development" && api) {
    //   config.headers.appV = api.appVersion;
    // } else {
    //   config.headers.appV = "";
    // }
    // console.log('-----入参-------', config.data);
      // 缓存原始请求体，供响应阶段定位不同请求维度
    if (config.method == "post") {
      config.data = reSetData(config.data, token_info?.token);
    } else {
      config.data = reSetData(config.data, token_info?.token);
    }
    
    return config;
  },
  error => {
    loadingManager.hide();
    Promise.reject(error);
  }
);

// response 拦截器
// 定义变量防止重复跳转
let loginRedirectPending = false
try {
  service.interceptors.response.use(
    response => {
      // store.commit("setShowLoading", false);
      if (response.config.loading) {
        loadingManager.hide();
      }
      // 某些接口不需要判错处理，所以直接返回就行，目前包括：埋点接口
      if (response.config.ignoreError) {
        return response.data
      }
      if (response.data) {
        // Toast.clear();
        const res = response.data;
        if(res.code != 20000) {
          stopLoading()
          window.$tracker.send({
            message: `#API#ERROR_CODE#${response?.config?.url}`,
            content: {
              url: response?.config?.url,
              method: response?.config?.method || 'GET',
              headers: response?.config?.headers,
              code: res?.code,
              logTraceId: res?.logTraceId,
              requestData: ['get', 'GET'].includes(response?.config?.method) ? response?.config?.params : response?.config?.data,
              responseData: res
            }
          });
          res.code !== 20021 && res.message && Toast({
            message: res.message,
            position: "bottom",
            duration: 3 * 1000
          });
        }
        if (res.code == 20000) {
          window.$tracker.send({
            message: '#API#-response',
            content: JSON.stringify({
              url: response.config.url,
              responseData: res
            }),
            docName: myJsTools.getItem("docUserInfo")?.docName || ''
          });
          return res;
        } else if (res.code == 20008) {
          if (!res.data) {
            res.data = {};
          }
          res.data.isLogin = true;
          return res;
        } else if (res.code == 20010) {
          if (!res.data) {
            res.data = {};
          }
          res.data.isUser = true;
          return res;
        } else if (res.code == 20017) {
          if (!res.data) {
            res.data = {};
          }
          res.data.isDoc = true;
          return res;
        } else if (res.code == 20014) {
          if (!res.data) {
            res.data = {};
          }
          res.data.isTel = true;
          return res;
        } else if (res.code == 20006) {
          //token 过期
          myJsTools.clearLogInfo(store)
          if(!loginRedirectPending) {
            loginRedirectPending = true
            router.replace({
              path: "/login"
            }).catch(err => {});
            // 1秒后重置，防止长时间锁死
            setTimeout(() => {
              loginRedirectPending = false
            }, 1000)
            // 
            return Promise.reject(res);
          }
          
        } else if (res.code == 20012) {
          //没有医院id
          myJsTools.clearLogInfo(store)
          router.replace({
            path: "/login"
          }).catch(err => {});
        } else if (res.code == 20001) {
          // Toast({
          //   message: res.message,
          //   position: "bottom",
          //   duration: 3 * 1000
          // });
          // myJsTools.uploadErrFile();
          return Promise.reject(res);
        //  系统升级
        } else if (res.code == 50007) {
          console.log("setForceupdate的返回值", res.data);
          store.commit("setForceupdate", {
            popup: true,
            iosUrl: res.data.ios,
            android: res.data.android
          });
          return Promise.reject(res);
        } else if (res.code == 20021) {
          if (!res.data) {
            res.data = {};
          }
          return res;
        } else {
          // Toast({
          //   message: res.message,
          //   position: "bottom",
          //   duration: 3 * 1000
          // });
          // myJsTools.uploadErrFile();
          return Promise.reject(res);
        }
      }
    },
    error => {
      // store.commit("setShowLoading", false);
      loadingManager.hide();
      // Toast({
      //   message: error.message,
      //   position: "bottom",
      //   duration: 3 * 1000
      // });
      return Promise.reject(error);
    }
  );
} catch (err) {}
export default service;
